import React from 'react';
import { CheckIcon, CreditCardIcon, EyeIcon, FlameIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { HERO_IMAGE, offerIncludes } from '../data/content';
import { OFFER_SIZES, OFFER_WIDTHS, optimizedImage, optimizedSrcSet } from '../utils/images';
import { CHECKOUT_URL, CtaButton } from './CtaButton';
import { Accent, SectionHeading } from './SectionHeading';
const trustBadges = [{
  icon: ZapIcon,
  label: 'Instant access'
}, {
  icon: CreditCardIcon,
  label: 'One-time payment'
}, {
  icon: ShieldCheckIcon,
  label: '7-day guarantee'
}, {
  icon: LockIcon,
  label: 'Secure checkout'
}];
export function OfferSection() {
  return <section id="offer" className="w-full scroll-mt-4 bg-cream-200 px-6 py-10 sm:py-12" aria-labelledby="offer-title" data-id="element-109" data-mp="rc3kq9e5ql0a">
      <div className="mx-auto max-w-2xl" data-id="element-110" data-mp="2t6b6yh3udxlj">
        <SectionHeading id="offer-title" badge="Special launch price" badgeIcon={FlameIcon} title={<>
              Surgical Shield System 2026 — <Accent data-id="element-112" data-mp="12otftht83dj0">Full Faculty Suite</Accent>
            </>} subtitle="The 11-part digital bundle for Surgical Technology educators." data-id="element-111" data-mp="2t7dy8q52u21z" />

        <div className="relative mx-auto mt-3 w-full max-w-sm" data-id="element-113" data-mp="syqp5o9kqbnu">
          <img src={optimizedImage(HERO_IMAGE, 420)} srcSet={optimizedSrcSet(HERO_IMAGE, OFFER_WIDTHS)} sizes={OFFER_SIZES} alt="Full contents of the Surgical Shield System 2026: 6 volumes and 5 bonuses" width={1000} height={1000} loading="lazy" decoding="async" className="h-auto w-full" data-id="element-114" data-mp="ow3pj16nvmg3" />
          <span className="absolute -right-1 top-2 flex h-24 w-24 flex-col items-center justify-center text-center font-display font-bold leading-none text-white sm:h-28 sm:w-28" style={{
          backgroundColor: '#0E72B8',
          clipPath: 'polygon(50% 0%, 61% 12%, 78% 6%, 82% 24%, 98% 30%, 90% 46%, 100% 60%, 84% 68%, 86% 86%, 68% 84%, 58% 98%, 44% 88%, 28% 96%, 24% 78%, 6% 74%, 12% 58%, 0% 44%, 14% 34%, 8% 16%, 26% 18%, 34% 2%)'
        }} data-id="element-115" data-mp="17mv6anszaf4i">
            <span className="text-2xl sm:text-3xl" data-id="element-116" data-mp="3ku2wtoh5chk6">80%</span>
            <span className="mt-1 text-[0.6rem] uppercase tracking-widest" data-id="element-117" data-mp="3kvnvnqahumnu">OFF</span>
          </span>
        </div>

        <div className="mt-3 rounded-3xl border border-white/10 bg-forest-800 px-6 py-7 text-center shadow-lift sm:px-10" data-id="element-118" data-mp="3b3rs3zpn24c8">
          <p className="text-sm text-cream-100/80" data-id="element-119" data-mp="3fv9veuf4wh0d">
            Normal price: <span className="line-through" data-id="element-120" data-mp="315bynq352izk">$235 USD</span>
          </p>

          <span className="mt-4 inline-flex items-center gap-2 rounded-full border border-ember-400/40 bg-ember-400/10 px-5 py-2 text-[0.7rem] font-bold uppercase tracking-[0.14em] text-ember-400" data-id="element-121" data-mp="313920n7hdrlv">
            <FlameIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-122" data-mp="2s6qnifzzy68t" />
            Launch price
          </span>

          <p className="mt-5 text-sm uppercase tracking-widest text-cream-100/80" data-id="element-123" data-mp="2x5jqhehnqeuq">Today only</p>
          <p className="mt-1 font-display text-5xl font-bold text-cream-50 sm:text-6xl" data-id="element-124" data-mp="2dk1ftqvlcmrc">$27 USD</p>

          <p className="mt-3 inline-flex items-center gap-2 text-xs text-ember-400" data-id="element-125" data-mp="28l6wmntpow6p">
            <EyeIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-126" data-mp="2mjy8s4p0k7s7" />
            14 instructors are viewing this offer right now
          </p>

          <CtaButton className="mt-6" variant="light" fullWidth href={CHECKOUT_URL} label="Yes, Give Me Instant Access" source="offer" data-id="element-127" data-mp="2wgjaag1tr0ra" />

          <ul className="mx-auto mt-6 grid max-w-xs grid-cols-2 gap-y-2 text-xs text-cream-100/85" data-id="element-128" data-mp="366vyqjcrfe2p">
            {trustBadges.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex items-center justify-center gap-1.5" data-id="element-129" data-mp="3f7ai3d65yj3k">
                <Icon className="h-3.5 w-3.5 text-ember-400/80" aria-hidden="true" data-id="element-130" data-mp="3f57wr6fyhe56" />
                {label}
              </li>)}
          </ul>

          <ul className="mt-7 grid gap-1.5 border-t border-white/10 pt-6 text-left" data-id="element-131" data-mp="18hz4lx3cx6xw">
            {offerIncludes.map(item => <li key={item} className="flex items-center gap-2 text-xs text-cream-100/80" data-id="element-132" data-mp="1dgaf8a1h7lh6">
                <CheckIcon className="h-3 w-3 shrink-0 text-ember-400" strokeWidth={3} aria-hidden="true" data-id="element-133" data-mp="1i9n0qbauzc5p" />
                <span className="min-w-0 flex-1 truncate" data-id="element-134" data-mp="1m9nhi2lfjzfx">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}